import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { UpdateLifetimeAllowanceClient } from "../../../../../../Wrap/Api/Account/UpdateLifetimeAllowance";
import { OffPlatformLifeTimeAllowance } from "../../../../../../Wrap/Models/Domains/Account/OffPlatformLifeTimeAllowance";
import { UpdateLifetimeAllowanceDispatcher, UpdateLifetimeAllowanceStore } from "../../UpdateLifetimeAllowanceWizard/Store/Variable";

export class UpdateLifetimeAllowanceAction {

    public static getInstruction(subAccountHierarchyId: string): void {
        const client = new UpdateLifetimeAllowanceClient();

        const promise = client.get(subAccountHierarchyId);

        promise.onSuccess((result) => {
            let data = JSON.parse(JSON.stringify(UpdateLifetimeAllowanceStore.getData()));
            if (!data) {data = {};}
            data = result;
            UpdateLifetimeAllowanceDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: data,
            });
        });

        promise.onError((err) => {
            UpdateLifetimeAllowanceDispatcher.dispatch({
                actionType: ActionType.Error,
                payload: err,
            });
        });
    }

    public static updateInstruction(getLifetimeAllowanceOffPlatform: number) {
        UpdateLifetimeAllowanceDispatcher.dispatch({
            actionType: ActionType.Update,
            payload: getLifetimeAllowanceOffPlatform,
        });
    }

    public static submitInstruction(subAccountHierarchyId: string, data: OffPlatformLifeTimeAllowance, callback?: (error) => void): void {
        const client = new UpdateLifetimeAllowanceClient();
        const promise = client.put(subAccountHierarchyId, data);

        promise.onSuccess((result) => {
            if (callback) {callback(result);}
        });

        promise.onError((err) => {
            UpdateLifetimeAllowanceDispatcher.dispatch({
                actionType: ActionType.Error,
                payload: err,
            });
        });

    }
}
